import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Use the `}<inlineCode parentName="p">{`Do`}</inlineCode>{` and `}<inlineCode parentName="p">{`Dont`}</inlineCode>{` components to provide good and bad examples within documentation.`}</p>
    <h2>{`Usage`}</h2>
    <p><inlineCode parentName="p">{`Do`}</inlineCode>{`, `}<inlineCode parentName="p">{`Dont`}</inlineCode>{` and `}<inlineCode parentName="p">{`DoDontContainer`}</inlineCode>{` are a `}<a parentName="p" {...{
        "href": "https://mdxjs.com/blog/shortcodes"
      }}>{`shortcodes`}</a>{`, meaning they are globally available in all `}<inlineCode parentName="p">{`.md`}</inlineCode>{` and `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` files. So you can use the `}<inlineCode parentName="p">{`Do`}</inlineCode>{`, `}<inlineCode parentName="p">{`Dont`}</inlineCode>{`, and `}<inlineCode parentName="p">{`DoDontContainer`}</inlineCode>{` components in any `}<inlineCode parentName="p">{`.md`}</inlineCode>{` or `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` file without importing them.`}</p>
    <h3>{`Side-by-side`}</h3>
    <p>{`To create a side-by-side Do/Don't example, wrap the `}<inlineCode parentName="p">{`Do`}</inlineCode>{` and `}<inlineCode parentName="p">{`Dont`}</inlineCode>{` components with the `}<inlineCode parentName="p">{`DoDontContainer`}</inlineCode>{` component:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<DoDontContainer>
  <Do>
    <img src="https://user-images.githubusercontent.com/586552/63106528-06de5100-bf51-11e9-8a5e-98583ed74874.png" />
    <Caption>Use brief and direct communication</Caption>
  </Do>
  <Dont>
    <img src="https://user-images.githubusercontent.com/586552/63106527-06de5100-bf51-11e9-858c-72de6a5c728a.png" />
    <Caption>Don't use wordy and redundant copy</Caption>
  </Dont>
</DoDontContainer>
`}</code></pre>
    <p><em parentName="p">{`Note: Caption text should describe the image and be able to stand on its own. The `}<inlineCode parentName="em">{`alt`}</inlineCode>{` prop should be used if a more detailed description of the image is needed.`}</em></p>
    <h3>{`Stacked`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`DoDontContainer`}</inlineCode>{` component also accepts a `}<inlineCode parentName="p">{`stacked`}</inlineCode>{` prop to create stacked Do/Don't examples:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<DoDontContainer stacked>
  <Do>
    <img src="https://user-images.githubusercontent.com/586552/63046880-46e5fb00-bea1-11e9-836d-be1b1c7d963f.png" />
    <Caption>Use a container class to give the text a max-width</Caption>
  </Do>
  <Dont>
    <img src="https://user-images.githubusercontent.com/586552/63046881-46e5fb00-bea1-11e9-87ee-80dbeb0bea1c.png" />
    <Caption>Don't let the text span the entire width of the window</Caption>
  </Dont>
</DoDontContainer>
`}</code></pre>
    <h3>{`Indented`}</h3>
    <p><inlineCode parentName="p">{`Do`}</inlineCode>{` and `}<inlineCode parentName="p">{`Dont`}</inlineCode>{` components can also be indented to increase the clarity of the example message within the documentation:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<DoDontContainer stacked>
  <Do indented>
    Place pane regions on the left to display navigation, filtering, or an
    overview for entities such as users, bots, apps, etc.
  </Do>
  <Dont indented>
    Don't display more than three columns of information on a page.
  </Dont>
</DoDontContainer>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      